import React, { useState } from 'react';
import styles from "./CheckState.less";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import langCommon, { getLangFromLocal } from '../../../../utils/lang.util';
import classNames from 'classnames';
import LabelItem from './LabelItem/LabelItem';
import { ProgressCircle } from "antd-mobile-v5";
CheckState.displayName = "CheckState";

CheckState.propTypes = {
  images: PropTypes.array,
  label: PropTypes.string,
  flag: PropTypes.string,
  degree: PropTypes.string,
  level: PropTypes.number,
  description: PropTypes.string,
};

function CheckState(props) {
  const { featureItem, featureList, images, flag, downloadUrl, featureImage, progressValue } = props;
  const { instanceName, instanceDegree, instanceLevel, result_enable } = featureItem;

  const [lang] = useState(getLangFromLocal());

  const getHash = () => {
    const { search = "?" } = window.location;
    const query = search.substring(1);

    const params = query.endsWith("=") ? query.slice(0, query.length - 1) : query;
    return params;
  };

  return (
    <div className={styles.checkStateWrap}>
      <div className={styles.checkStateTitle}>
        <span className={styles.checkStateLabel}>{instanceName}</span>
        {!!result_enable && (
          <div className={classNames(styles.checkStateLevel, styles[`level${instanceLevel}`])}>{instanceDegree}</div>
        )}
      </div>
      <div className={styles.featureItemWrapper}>
        {featureList?.map((item, index) => (
          <LabelItem
            key={index}
            item={item?.name}
            level={item?.level}
            style={classNames(styles.featureItem, {
              [styles.featureNameActive]: item?.name === featureItem?.name,
            },)}
          />
        ))}
      </div>
      <div className={styles.checkStateContent}>
        <div className={styles.checkStateLeft}>
          <div>{featureItem?.name}: {featureItem?.result}{langCommon.score(lang)}</div>
          {featureItem?.detail?.physical_values?.map((physical) => (
            <div>{physical?.title}: {physical?.value}
              {physical?.unit === "%" ? `${physical?.unit}` : ` ${physical?.unit}`}
            </div>
          ))}
        </div>
        <div>
          <Link
            to={{ pathname: `/skinReportChart/${getHash()}`, state: { flag, images, downloadUrl } }}
            className={styles.checkStateImage}
          >
            {progressValue !== 100 && !featureImage ?
              <div className={styles.progressCircleWrap}>
                <ProgressCircle percent={progressValue} style={{ '--size': '40px' }}>{progressValue}%</ProgressCircle>
              </div>
              :
              <img alt="" src={featureImage} />
            }
            <div className={styles.arrowIcon}>
              <svg width="1em" height="1em" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M35.75 13.25H29M35.75 13.25V20M35.75 13.25L27.875 21.125M13.25 35.75H20M13.25 35.75V29M13.25 35.75L21.125 27.875" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M47 24.5C47 35.1065 47 40.4097 43.7037 43.7037C40.412 47 35.1065 47 24.5 47C13.8935 47 8.59025 47 5.294 43.7037C2 40.412 2 35.1065 2 24.5C2 13.8935 2 8.59025 5.294 5.294C8.5925 2 13.8935 2 24.5 2C35.1065 2 40.4097 2 43.7037 5.294C45.8952 7.4855 46.6287 10.5657 46.8762 15.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
          </Link>
        </div>
      </div>
      <div>
        <div className={styles.checkStateDescriptionTitle}><span></span>{langCommon.causeAnalysis(lang)}</div>
        <div className={styles.checkStateDescription}>{featureItem?.detail?.reason}</div>
      </div>
    </div>
  );
}

export default CheckState;
